import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { components } from '@awj/api-client';

import { admin } from './queries.ts';

type SaveCoupon = components['schemas']['SaveCouponRequest'];

export function useCoupons() {
  return useQuery({
    queryKey: ['coupons'],
    queryFn: () => admin().coupons(),
  });
}

export function useSaveCoupon() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number | null; body: SaveCoupon }) =>
      id === null ? admin().createCoupon(body) : admin().updateCoupon(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['coupons'] }),
  });
}

export function useDeleteCoupon() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => admin().deleteCoupon(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['coupons'] }),
  });
}
